import {createAction} from '@ngrx/store';

import {Notifications, VaBatchStatus, VaTimecardStatus} from '../../../../common/notification.model';

export const OnMessage = createAction(
  '[Notification] On SSE Message',
  (message: Notifications) => ({ message })
);

export const OnError = createAction('[Notification] On SSE Error', error => error);

export const OnSSEConnected = createAction('[Notification] SSE Connected');

export const OnSSEDisconnected = createAction('[Notification] SSE Disonnected');

export const VaTimecardStatusUpdate = createAction(
  '[Notification] Va Timecard Status Update',
  (message: VaTimecardStatus) => ({ message })
);

export const VaBatchStatusUpdate = createAction(
  '[Notification] Va Batch Status Update',
  (message: VaBatchStatus) => ({ message })
);
